export type AutomaticLogoutContext = {
  reason: "refresh_rejected" | "credentials_missing";
  operation: string;
  status?: number;
};

type AutomaticLogoutListener = (context: AutomaticLogoutContext) => void;

const listeners = new Set<AutomaticLogoutListener>();

export function subscribeToAutomaticLogout(listener: AutomaticLogoutListener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function announceAutomaticLogout(context: AutomaticLogoutContext) {
  listeners.forEach((listener) => listener(context));
}
